const regex = {
  empty: /^\s+/,
  specialCharactes: /[^\w]/gi,
  specialCharactesWithouSpace: /[^\w\s]/gi,
  lettersWithSpecialCharacters: /[\D]/gi,
};

export default regex;
